import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  data() {
    return {
      id: this.$options.name,
      selectedStepId: "transfer",
      selectedLastStepId: null,
      selectedStepData: {},
      steps: [
        {
          id: "transfer",
          nextStepIds: [
            "transfer-files", //selection menu
            "transfer-collections",
            "transfer-upload",
          ],
          lastStepId: "",
          wipeTransfers: true,
        },
        /* quick-transfer */
        {
          id: "transfer-upload", //selection upload
          groupId: "quickTransfer",
          nextStepIds: ["transfer-uploading"],
          lastStepId: "transfer",
          wipeTransfers: true,
        },
        {
          id: "transfer-upload-preview", //preview of to upload files
          groupId: "quickTransfer",
          nextStepIds: ["transfer-uploading"],
          lastStepId: "transfer-upload",
          wipeTransfers: false,
        },
        {
          id: "transfer-uploading", //selection upload
          groupId: "quickTransfer",
          nextStepIds: ["transfer-ready"],
          lastStepId: "transfer-upload-preview",
          wipeTransfers: false,
        },
        {
          id: "transfer-quick-ready",
          groupId: "quickTransfer",
          lastStepId: "transfer", //based on last picked
          wipeTransfers: true,
        },
        {
          id: "transfer-quick-succes",
          groupId: "quickTransfer",
          lastStepId: "transfer",
          wipeTransfers: true,
        },
        /* END quick-transfer */
        /* file-tranfer */
        //used for the overlay section
        //NOTE: transfer-home component stays in the background of these instances. So that if it is closed the transfer home is ready once more
        {
          id: "transfer-ready",
          groupId: "fileTransfer",
          lastStepId: "",
          wipeTransfers: false,
        },
        {
          id: "transfer-succes",
          groupId: "fileTransfer",
          lastStepId: "",
          wipeTransfers: true,
        },
        /* END file-tranfer */
      ],
    };
  },
  beforeMount() {
    //check if mobile
    this.redirect();
  },
  created() {
    setDocTitle("transfer", this);

    EventBus.$on(`${this.id}-updateStep`, this.updateStep);

    EventBus.$on(`${this.id}-findItems`, this.findItems);

    EventBus.$on(`closeOverlayPage`, this.returnToPreviousPage);

    this.checkTransferReady();

    this.resetUrl();
  },

  methods: {
    returnToPreviousPage(data) {
      if (
        data.id === "mobile-transfer" &&
        !this.selectedLastStepId &&
        this.$store.state.isTransfering
      ) {
        //close overlay is here and there is no last step
        //so wipe and go back
        this.setTransferMode(false);

        this.$router.go(-1);
      }
    },
    resetUrl() {
      this.$router.replace(`/${this.$store.state.company}/mobile-transfer`);
    },
    uploadDone() {
      EventBus.$emit(`${this.id}-updateStep`, {
        id: "transfer-quick-ready",
      });
    },
    findItems(data) {
      this.setTransferMode(true);

      this.$router.push(`/${this.$store.state.company}/${data.link}`);
    },
    setTransferMode(setting) {
      this.$store.state.isTransfering = setting;

      if (!setting) {
        //wipe data if not transfering anymore
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collection: {},
        };
      }
    },
    checkTransferReady() {
      const items = this.$store.state.transferItems;
      let hasItems = false;

      Object.keys(items).forEach((key) => {
        if (Array.isArray(items[key])) {
          if (items[key].length > 0) {
            hasItems = true;
          }
        } else {
          if (items[key].id) {
            hasItems = true;
          }
        }
      });

      if (hasItems) {
        //go to tranfer ready
        EventBus.$emit(`${this.id}-updateStep`, {
          id: "transfer-ready",
          lastStepId: "",
        });
      } else {
        //go to home screen
        EventBus.$emit(`${this.id}-updateStep`, {
          id: "transfer",
          lastStepId: "",
        });
      }
    },
    redirect() {
      if (!this.$store.state.isMobile) {
        //is desktop so go to main screen
        this.$router.replace(`/${this.$store.state.company}`);
      }
    },

    updateStep(data) {
      this.selectedStepId = data.id;
      this.selectedStepData = this.steps.filter(
        (step) => step.id === data.id
      )[0];

      //add extra data if present
      if (data.data) {
        this.selectedStepData.data = data.data;
      }

      //set last step
      this.selectedLastStepId = data.lastStepId
        ? data.lastStepId
        : this.selectedStepData.lastStepId;

      //wipe transferData if needed
      if (this.selectedStepData.wipeTransfers) {
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collection: {},
        };
      }

      //update the url
      if (data.id !== "transfer") {
        this.$router.push(
          `/${this.$store.state.company}/mobile-transfer/${data.id.replace(
            "transfer-",
            ""
          )}`
        );
      } else if (
        this.$route.path !== `/${this.$store.state.company}/mobile-transfer`
      ) {
        this.$router.push(`/${this.$store.state.company}/mobile-transfer`);
      }
    },
    checkGroupId(groupId) {
      //check if the selected step is currently in use
      //used to display it's parent based on the group id

      return (
        this.steps.filter((step) => {
          return step.groupId === groupId && step.id === this.selectedStepId;
        }).length > 0
      );
    },
  },
  computed: {
    isFileTransfer() {
      return this.checkGroupId("fileTransfer");
    },

    isQuickTransfer() {
      return this.checkGroupId("quickTransfer");
    },
  },
};
